import { useState } from 'react'
import type { Project, TaskSource } from '../lib/api'

export const SOURCE_OPTIONS: { value: TaskSource; label: string }[] = [
  { value: 'dify', label: 'Dify' },
  { value: 'opencode', label: 'OpenCode' },
  { value: 'supercoldbuilder', label: 'SuperColdBuilder' },
  { value: 'manual', label: 'Manuel' },
]

interface TaskFormProps {
  projects: Project[]
  selectedProjectId: number | null
  onProjectSelect: (id: number) => void
  onCreate: (data: { title: string; session_link?: string; source?: TaskSource }) => void
}

export default function TaskForm({
  projects,
  selectedProjectId,
  onProjectSelect,
  onCreate,
}: TaskFormProps) {
  const [title, setTitle] = useState('')
  const [sessionLink, setSessionLink] = useState('')
  const [source, setSource] = useState<TaskSource>('manual')

  const submit = () => {
    const t = title.trim()
    if (!t || selectedProjectId == null) return
    onCreate({
      title: t,
      session_link: sessionLink.trim() || undefined,
      source,
    })
    setTitle('')
    setSessionLink('')
    setSource('manual')
  }

  return (
    <div className="bg-white rounded-xl border border-kanban-border shadow-sm p-4">
      <h3 className="text-sm font-semibold text-text-primary mb-3">Nouvelle tâche</h3>
      <div className="flex flex-wrap items-end gap-3">
        <div className="flex flex-col gap-1">
          <label className="text-xs text-text-soft">Titre</label>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && submit()}
            placeholder="Intitulé de la tâche…"
            className="bg-kanban-bg border border-kanban-border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-kanban-navy w-64"
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-xs text-text-soft">Projet</label>
          <select
            value={selectedProjectId ?? ''}
            onChange={(e) => onProjectSelect(Number(e.target.value))}
            className="bg-kanban-bg border border-kanban-border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-kanban-navy"
          >
            {projects.length === 0 && <option value="">Aucun projet</option>}
            {projects.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-xs text-text-soft">Lien session (optionnel)</label>
          <input
            value={sessionLink}
            onChange={(e) => setSessionLink(e.target.value)}
            placeholder="https://…"
            className="bg-kanban-bg border border-kanban-border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-kanban-navy w-56"
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-xs text-text-soft">Source</label>
          <select
            value={source}
            onChange={(e) => setSource(e.target.value as TaskSource)}
            className="bg-kanban-bg border border-kanban-border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-kanban-navy"
          >
            {SOURCE_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </div>

        <button
          onClick={submit}
          className="px-4 py-2 rounded-lg bg-kanban-navy text-white text-sm font-medium hover:bg-kanban-navy-soft transition"
        >
          Ajouter
        </button>
      </div>
    </div>
  )
}
